import { createContext, useContext } from 'react'
import type { ChatUiActionData } from 'tripPlanner/api/types'

export interface ChatUiActionValue {
  pendingUiAction: ChatUiActionData | undefined
  clearPendingUiAction: () => void
}

export const ChatUiActionContext = createContext<ChatUiActionValue | undefined>(undefined)

export function useChatUiAction(): ChatUiActionValue {
  const ctx = useContext(ChatUiActionContext)
  if (!ctx) throw new Error('useChatUiAction must be used within TripPlannerChatProvider')
  return ctx
}
